var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_1699_4436)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99431 11.896L13.0752 8.56647C13.8729 8.21965 16.5781 7.10983 16.5781 7.10983C16.5781 7.10983 17.8267 6.62428 17.7226 7.80347C17.6879 8.28902 17.4105 9.98844 17.133 11.8266L16.266 17.2717C16.266 17.2717 16.1966 18.0694 15.607 18.2081C15.0174 18.3468 14.0463 17.7225 13.8729 17.5838C13.7342 17.4798 11.2718 15.9191 10.37 15.1561C10.1273 14.948 9.8498 14.5318 10.4047 14.0462C11.6533 12.9017 13.1446 11.4798 14.0463 10.578C14.4625 10.1618 14.8787 9.19075 13.1446 10.3699L8.25442 13.6647C8.25442 13.6647 7.69951 14.0116 6.65905 13.6994C5.61858 13.3873 4.40471 12.9711 4.40471 12.9711C4.40471 12.9711 3.57234 12.4509 4.99431 11.896Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1699_4436",
    x1: 16.0009,
    y1: 4.00092,
    x2: 10.0009,
    y2: 18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.b7f6f87ac41229dd6b70e3f967bfe3ba.svg";
export { ForwardRef as ReactComponent };